import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import persistReducer from "redux-persist/lib/persistReducer";
import reducers from "./reducers";
import {configureStore} from "@reduxjs/toolkit";
import {FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE} from "redux-persist/es/constants";
import {encryptTransform} from "redux-persist-transform-encrypt";

const persistConfig = {
    key: "bearu-b2b",
    transforms: [
        encryptTransform({
            secretKey: "G+KbPeShVmYq3t6w9y$B&E)H@McQfTjW",
            onError: function (error) {
                // Handle the error.
            },
        }),
    ],
    storage: storage,
};

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    devTools: process.env.NODE_ENV !== "productions",
})
export const persistor = persistStore(store);



